/**
 * 환경변수 설정
 * 모든 값은 .env.local 또는 .env.production 파일에서 관리합니다.
 */

interface EnvConfig {
  NODE_ENV: 'development' | 'production' | 'test';
  REACT_APP_ENV: 'local' | 'production' | 'test';
  REACT_APP_API_URL: string;
  REACT_APP_APP_NAME: string;
  REACT_APP_VERSION: string;
  REACT_APP_DEBUG: boolean;
  REACT_APP_LOG_LEVEL: 'debug' | 'info' | 'warn' | 'error';
  REACT_APP_CSRF_TOKEN_URL: string;
  REACT_APP_CSRF_HEADER_NAME: string;
  REACT_APP_CSRF_COOKIE_NAME: string;
  REACT_APP_USE_MOCK: boolean;
  REACT_APP_ENABLE_ANALYTICS: boolean;
  REACT_APP_ENABLE_ERROR_REPORTING: boolean;
}

/**
 * 환경변수에서 값을 읽어옵니다.
 * 필수 값이 없으면 콘솔에 경고를 출력합니다.
 */
const getEnvVar = (key: string, defaultValue?: string): string => {
  const value = process.env[key];
  if (!value && !defaultValue) {
    // console.warn(`⚠️ 환경변수 ${key}가 설정되지 않았습니다.`);
    return '';
  }
  return value || defaultValue || '';
};

const env: EnvConfig = {
  NODE_ENV: (process.env.NODE_ENV as EnvConfig['NODE_ENV']) || 'development',
  REACT_APP_ENV: (getEnvVar('REACT_APP_ENV', 'local') as EnvConfig['REACT_APP_ENV']),
  REACT_APP_API_URL: getEnvVar('REACT_APP_API_URL'),
  REACT_APP_APP_NAME: getEnvVar('REACT_APP_APP_NAME', 'Smart Book'),
  REACT_APP_VERSION: getEnvVar('REACT_APP_VERSION', '1.0.0'),
  REACT_APP_DEBUG: getEnvVar('REACT_APP_DEBUG') === 'true',
  REACT_APP_LOG_LEVEL: (getEnvVar('REACT_APP_LOG_LEVEL', 'error') as EnvConfig['REACT_APP_LOG_LEVEL']),
  REACT_APP_CSRF_TOKEN_URL: getEnvVar('REACT_APP_CSRF_TOKEN_URL'),
  REACT_APP_CSRF_HEADER_NAME: getEnvVar('REACT_APP_CSRF_HEADER_NAME', 'X-CSRF-Token'),
  REACT_APP_CSRF_COOKIE_NAME: getEnvVar('REACT_APP_CSRF_COOKIE_NAME', 'csrf-token'),
  REACT_APP_USE_MOCK: getEnvVar('REACT_APP_USE_MOCK') === 'true',
  REACT_APP_ENABLE_ANALYTICS: getEnvVar('REACT_APP_ENABLE_ANALYTICS') === 'true',
  REACT_APP_ENABLE_ERROR_REPORTING: getEnvVar('REACT_APP_ENABLE_ERROR_REPORTING') === 'true',
};

export default env;
